// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__2nqYE","gfeWrapper":"CalendarEvent_gfeWrapper__3rymw"};